import {
  BackNextSkip,
  clearValidation,
  isValidAmount,
  required,
  ruleRunner,
  run,
  TextInput,
} from '@assetmark/common-elements';
import { currencyFormatter } from '@assetmark/utilities';
import React, { useEffect, useState } from 'react';
import { TGoal } from '../../models/goal';
import { convertDollarStringToNumber } from '../../utils/format.utils';
import styles from './annual-contribution.module.css';

export interface TAnnualContributionProps {
  goal?: TGoal;
  // goalTypes?: TGoalType[];
  // investmentAmount: number;
  onBackButtonClick?: () => void;
  onSkipGoal?: () => void;
  saveInvestorProfile?: (annualAmount: number) => void;
}

const AnnualContribution: React.FC<TAnnualContributionProps> = (props) => {
  const [goal, setGoal] = useState<TGoal>(props.goal);
  const [buttonClass, setButtonClass] = useState<string>('disabled');
  const [showErrors, setShowErrors] = useState<boolean>(false);
  const [validationErrors, setValidationErrors] = useState({
    AnnualSavings: '',
  });
  const [annualContribution, setAnnualContribution] = useState<string>(
    props.goal.AnnualSavings !== 0
      ? currencyFormatter(props.goal.AnnualSavings / 12)
      : '',
  );
  const [isComplete, setIsComplete] = useState<boolean>(false);
  const [fieldValidations, setFieldValidations] = useState<{
    AnnualSavings: (state: any) => void;
  }>({
    AnnualSavings: ruleRunner('AnnualSavings', 'amount', [
      required,
      isValidAmount(0, 999999),
    ]),
  });

  useEffect(() => {
    if (props.goal && props.goal.AnnualSavings) {
      setAnnualContribution(
        props.goal.AnnualSavings !== 0
          ? currencyFormatter(props.goal.AnnualSavings / 12)
          : '',
      );
      validateProfile('AnnualSavings', true);
    }
  }, [props.goal]);

  useEffect(() => {
    setButtonClass(isComplete ? '' : 'disabled');
  }, [isComplete]);

  const isContributionAmountValid = (
    goal: TGoal,
    validationErrors?: any,
  ): boolean => {
    let errorOnPage = false;
    let returnItem = false;
    if (validationErrors && validationErrors.AnnualSavings.length > 0) {
      errorOnPage = true;
    }
    if (
      (goal.AnnualSavings === 0 || goal.AnnualSavings > 0) &&
      errorOnPage === false
    ) {
      returnItem = true;
    }
    return returnItem;
  };

  const validateProfile = (field: any, onChange: boolean) => {
    const currentGoalState = { ...goal };
    const errors = onChange
      ? run(currentGoalState, [ruleRunner(field, '', [clearValidation])])
      : run(currentGoalState, [fieldValidations[field]]);
    const updatedValidationErrors = { ...validationErrors, ...errors };
    const isAmountValid = isContributionAmountValid(currentGoalState, errors);

    setGoal(currentGoalState);
    setIsComplete(isAmountValid);
    setShowErrors(true);
    setValidationErrors(updatedValidationErrors);
  };

  const updateProfileState = (event: any): void => {
    // Update the investor that is present in the current component's state
    const field = event.target.name;
    const amount = convertDollarStringToNumber(event.target.value);
    const amountFormated = amount
      ? currencyFormatter(event.target.value)
      : event.target.value;
    const updatedInvestor = { ...goal };
    updatedInvestor[field] = amount * 12;

    setGoal(updatedInvestor);
    setAnnualContribution(amountFormated);
    const errors = run(updatedInvestor, [
      ruleRunner(field, '', [clearValidation]),
    ]);
    const isAmountValid = isContributionAmountValid(updatedInvestor, errors);
    setIsComplete(isAmountValid);
    const updatedValidationErrors = { ...validationErrors, ...errors };
    setValidationErrors(updatedValidationErrors);
  };

  const handleBackButtonClick = (event: any): void => {
    props.onBackButtonClick && props.onBackButtonClick();
  };
  const handleSave = (event: any): void => {
    props.saveInvestorProfile &&
      props.saveInvestorProfile(
        goal.AnnualSavings,
      );
  };

  return (
    <div className={`${styles.annual_contribution_component}`}>
      <div className="col-sm-12">
        <h1 className={styles.title}>Monthly Contributions</h1>
        <div className={`row ${styles.label_text}`}>
          <div className="col-sm-12">
            I’m saving $
            <TextInput
              className={`${styles.text__annual_contribution} ${
                validationErrors.AnnualSavings &&
                validationErrors.AnnualSavings.length
                  ? styles.errorClass
                  : ''
              }`}
              value={annualContribution}
              placeHolder=""
              onChange={updateProfileState}
              onBlur={(e) => validateProfile(e.target.name, false)}
              showError={showErrors}
              errorText={validationErrors.AnnualSavings}
              name="AnnualSavings"
              type="underline"
              maxLength={7}
            />
            per month for my retirement.
          </div>
        </div>
        <div className={styles.mt_row_btn}>
          <BackNextSkip
            backButtonClassName={`button button-secondary button-lg ${styles.btnLineHeight}`}
            backButtonText="BACK"
            onBackButtonClickHandler={handleBackButtonClick}
            nextButtonClassName={`button button-primary button-lg ml-2 ${styles.btnLineHeight} ${buttonClass}`}
            nextButtonText="ASSESS RISK PROFILE"
            onNextButtonClickHandler={handleSave}
            skipText=""
            isDisabledNextButton={buttonClass ? true : false}
          />
        </div>
      </div>
    </div>
  );
};

export default AnnualContribution;
